import { render, staticRenderFns } from "./Conversation.vue?vue&type=template&id=06676410&scoped=true&"
import script from "./Conversation.vue?vue&type=script&lang=js&"
export * from "./Conversation.vue?vue&type=script&lang=js&"
import style0 from "./Conversation.vue?vue&type=style&index=0&id=06676410&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06676410",
  null
  
)

export default component.exports